export class Upload {
    filePath: string;
    name: string;
    imagePath: string;
    audioPath: string;
    videoPath: string;
  Data: string;
}